import { Box, Divider, Popover } from '@material-ui/core';
import React, { useState } from 'react';

import { Font } from '@/components/shared/components/Font';
import { StandardButton } from '@/components/shared/components/StandardButton';
import { Text } from '@/components/shared/components/Text';
import { useConfigContext } from '@/contexts/ConfigContext/ConfigContext';
import { useCustomTheme } from '@/hooks/useCustomTheme';

interface FiltersDropdownToolProps {
  paperWidth?: number;
  buttonLabel?: JSX.Element;
  hasActiveFilters?: boolean;
  activeFiltersDeviationCount?: number;
  onResetFilters?: () => void;
  children: React.ReactNode;
}

export const FiltersDropdownTool = ({
  paperWidth = 360,
  buttonLabel = <Text tId={'FILTERS'} />,
  hasActiveFilters = false,
  activeFiltersDeviationCount = 0,
  onResetFilters,
  children,
}: FiltersDropdownToolProps) => {
  const { palette, shape } = useCustomTheme();
  const {
    state: { dictionaryValues },
  } = useConfigContext();

  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  return (
    <Box style={{ padding: '4px', borderRadius: shape.borderRadius }}>
      <StandardButton
        aria-label={dictionaryValues.FILTERS ?? 'Filters'}
        size="small"
        variant="text"
        // variant={hasActiveFilters ? 'outlined' : 'text'}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        startIcon={
          <i className="material-icons-outlined" style={{ fontSize: 22, paddingRight: 4 }}>
            filter_alt
          </i>
        }
        endIcon={
          hasActiveFilters ? (
            <Box
              style={{
                position: 'absolute',
                display: 'flex',
                left: '2px',
                top: '-1px',
                minWidth: 16,
                height: 16,
                paddingInline: activeFiltersDeviationCount > 9 ? 4 : 0,
                borderRadius: 999,
                background: palette.secondary.main,
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Font
                variant="overline"
                style={{
                  fontWeight: 700,
                  fontSize: 8,
                  color: palette.secondary.contrastText,
                  letterSpacing: 0,
                }}
              >
                {activeFiltersDeviationCount}
              </Font>
            </Box>
          ) : undefined
        }
        style={{ maxWidth: 120, minHeight: 42, paddingInline: 12 }}
      >
        <Font variant="body2" color="textPrimary">
          {buttonLabel}
        </Font>
      </StandardButton>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          style: {
            width: paperWidth,
            paddingBlock: '12px',
          },
        }}
      >
        {children}
        {onResetFilters && (
          <>
            <Divider />
            <Box px={2} pt={2}>
              <StandardButton
                fullWidth
                size="small"
                variant="text"
                color="secondary"
                onClick={() => {
                  onResetFilters();
                  setAnchorEl(null);
                }}
              >
                <Text tId="RESET_FILTERS" />
              </StandardButton>
            </Box>
          </>
        )}
      </Popover>
    </Box>
  );
};
